export default __webpack_public_path__ + "370f6764f8056efd96f6cfbb83d30e78.png";